import React, {useCallback, useEffect, useState} from "react";
import {
    Button,
    ButtonGroup, Card,
    CardContent,
    CardMedia, Checkbox,
    FormControlLabel, FormGroup, InputBase, ListItem, Menu, MenuItem,
    Switch,
    Tab, TextField
} from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import {capitalizeFirstLetter} from "../../Helpers/TextStyling";
import IconButton from "@mui/material/IconButton";
import currencyList from "../../../sampleData/currencyList";
import {useGoogleAutocompleteForAddress, useGoogleAutocompleteForEstablishment} from "../../Helpers/GoogleAutocomplete";
import PALocation from "../../../MasterEventObjects/Location";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import {useDropzone} from "react-dropzone";
import dayjs from "dayjs";
import {DatePicker} from "@mui/x-date-pickers";


// Simulated AI function (Replace with actual API call)
const processReceiptsWithAI = async (receiptFiles, account) => {
    return receiptFiles.map((file, index) => ({
        id: dayjs().valueOf()+index,
        attendee_id: account?.id || "",
        amount: 0,
        currency: 'USD',
        file_type: file.type,
        file_name: file.name,
        file_size: file.size,
        full_data: file.full_data,
        full_data_loaded: false,
        thumbnail_data: "",
        thumbnail_loaded: false,
        location: {
            google_place_id:"",
            latitude: 0,
            longitude: 0,
            name:"",
            formatted_address:"",
            address:"",
            city:"",
            state:"",
            zip:"",
            country:"",
            phone_prefix:"",
            phone:"",
        },
        section: "General",
        section_item: 0,
        private: false,
        notes: "",
        last_modified: 0,
        status: 0,
        showDetails: false, // New: Controls the visibility of details
    }));
};



function ReceiptsEditCard(props){

    console.log("editing receipt : ", props.receipt);

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    const [ eventReceipt, setEventReceipt ] = useState(props.receipt);
    const [selectedAction, setSelectedAction] = useState("");
    const [receiptTabSelected, setReceiptTabSelected] = useState("");
    const [uniqueLocations, setUniqueLocations] = useState([]);
    const [receiptLocation, setReceiptLocation] = useState(props.receipt.location);

    useEffect(() => {
        // Add `locationGroup` to each item
        const meals = (PA_GlobalObject.Planning.meals || []).map(meal => ({
            ...meal,
            locationGroup: 'Meals'
        }));

        const lodging = (PA_GlobalObject.Planning.lodging || []).map(lodge => ({
            ...lodge,
            locationGroup: 'Lodging'
        }));

        const activities = (PA_GlobalObject.Planning.activities || []).map(activity => ({
            ...activity,
            locationGroup: 'Activities'
        }));

        // Combine all locations
        const allLocations = [
            ...meals.map(meal => ({ ...meal.location, locationGroup: 'Meals' })),
            ...lodging.map(lodge => ({ ...lodge.location, locationGroup: 'Lodging' })),
            ...activities.map(activity => ({ ...activity.location, locationGroup: 'Activities' })),
        ];

        // Filter unique locations by Google Place ID or another unique property
        const unique = Array.from(
            new Map(
                allLocations
                    .filter(location => location.name && location.google_place_id) // Exclude locations without a name
                    .map((location) => [location.google_place_id, location])
            ).values()
        );

        // Sort the unique locations alphabetically by name
        const sortedUnique = unique.sort((a, b) => {
            const nameA = (a.name || "").toLowerCase();
            const nameB = (b.name || "").toLowerCase();
            return nameA.localeCompare(nameB);
        });

        // Separate the matching location from the rest
        const matchingLocation = sortedUnique.filter(
            (location) =>
                receiptLocation &&
                location.google_place_id === receiptLocation.google_place_id
        );

        const otherLocations = sortedUnique.filter(
            (location) =>
                !receiptLocation ||
                location.google_place_id !== receiptLocation.google_place_id
        );

        // Combine matching location(s) on top with the rest alphabetically sorted
        const finalLocationList = [...matchingLocation, ...otherLocations];

        console.log("finalLocationList : ",finalLocationList);

        setUniqueLocations(finalLocationList);
    }, []);

    useEffect(() => {
        if (props.receipt !== eventReceipt){
            setEventReceipt(props.receipt);
            setReceiptLocation(props.receipt.location);
            setNotes(props.receipt.notes)
        }
    }, [props.receipt]);
    useEffect(() => {
        console.log("the updated receipt : ", eventReceipt);
        props.updateReceipt(eventReceipt);
    }, [eventReceipt]);


    const handleFooterItemClick = (_item) => {
        setSelectedAction(_item);
        receiptTabSelected === _item ? setReceiptTabSelected("") : setReceiptTabSelected(_item);
    };

    /*
        for the receipt location
     */
    // State for location
    const [tabValueLocation, setTabValueLocation] = useState("locations");
    const handleTabLocationChange  = (event, newValue) => {
        console.log("handleTabLocationChange ");
        setTabValueLocation(newValue);
    };
    const [mapSearchType, setMapSearchType] = useState("establishment");
    const [mapSearchText, setMapSearchText] = useState("");
    const handleSearchTypeChange = (type) => {
        setMapSearchType(type);
        setMapSearchText(''); // Clear the input when switching search types
    };
    const handleMapSearchInput = (event) => {
        const searchText = event.target.value;
        setMapSearchText(searchText);
    };

    useEffect(() => {
        console.log("an update to the Receipt Location : "+eventReceipt.title,  receiptLocation);

        if (receiptLocation){
            setEventReceipt((prev) => {
                // Only update section if locationGroup is defined
                const newSection = receiptLocation.locationGroup
                    ? (prev.section === receiptLocation.locationGroup ? prev.section : receiptLocation.locationGroup)
                    : prev.section;

                return {
                    ...prev,
                    location: receiptLocation,
                    section: newSection,
                };
            });
        }

    }, [receiptLocation]);
    // Handle field changes with one reusable function
    function handleLocationFieldChange(event, field){
        const value = event.target.value;
        setReceiptLocation((prev) => ({
            ...prev,
            [field]: value
        }));

        if (field === "name" && eventReceipt){
            //update the
        }
    };
    const [addressFieldsResidential, setAddressFieldsResidential] = useState({
        google_place_id: '',
        latitude: 0,
        longitude: 0,
        formatted_address: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
    });
    const { inputRefResidential, attachAutocompleteResidential, removePacContainerResidential } = useGoogleAutocompleteForAddress((parsedAddress) => {
        setAddressFieldsResidential({
            google_place_id: parsedAddress.google_place_id,
            latitude: parsedAddress.latitude,
            longitude: parsedAddress.longitude,
            formatted_address: parsedAddress.formatted_address,
            address: parsedAddress.address,
            city: parsedAddress.city,
            state: parsedAddress.state,
            zip: parsedAddress.zip,
            country: parsedAddress.country,
        });
    });
    const [addressFieldsEstablishment, setAddressFieldsEstablishment] = useState({
        google_place_id: '',
        latitude: 0,
        longitude: 0,

        name: '',
        formatted_address: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        phone_prefix: '',
        phone: '',

        types: [],
        hours: [],
        website: "",
        photos: [],
        price_level: 0,
        rating: 0.0,
        total_ratings: 0,
    });
    const { inputRefEstablishment, attachAutocompleteEstablishment, removePacContainerEstablishment } = useGoogleAutocompleteForEstablishment((parsedAddress) => {
        setAddressFieldsEstablishment({
            google_place_id: parsedAddress.google_place_id,
            latitude: parsedAddress.latitude,
            longitude: parsedAddress.longitude,

            name: parsedAddress.name,
            formatted_address: parsedAddress.formatted_address,
            address: parsedAddress.address,
            city: parsedAddress.city,
            state: parsedAddress.state,
            zip: parsedAddress.zip,
            country: parsedAddress.country,
            phone_prefix: parsedAddress.phone_prefix,
            phone: parsedAddress.phone,

            types: parsedAddress.types,
            hours: parsedAddress.hours,
            website: parsedAddress.website,
            photos: parsedAddress.photos,
            price_level: parsedAddress.price_level,
            rating: parsedAddress.rating,
            total_ratings: parsedAddress.total_ratings
        });
    });
    useEffect(() => {
        const newLocation = new PALocation();
        Object.assign(newLocation, addressFieldsResidential);

        if (
            newLocation.google_place_id &&                                      // Make sure it's not empty
            JSON.stringify(newLocation) !== JSON.stringify(receiptLocation)   // Ensure it's different
        ) {
            console.log("Updating activity location from residential:", newLocation);
            setReceiptLocation(newLocation);
        }

        setMapSearchText('');
    }, [addressFieldsResidential]);
    useEffect(() => {
        const newLocation = new PALocation();
        Object.assign(newLocation, addressFieldsEstablishment);

        if (
            newLocation.google_place_id &&
            JSON.stringify(newLocation) !== JSON.stringify(receiptLocation)
        ) {
            console.log("Updating receipt location from establishment:", newLocation);
            setReceiptLocation(newLocation);
        }

        setMapSearchText('');
    }, [addressFieldsEstablishment]);
    function handleLocationSelect(location) {
        setReceiptLocation((prevLocation) => {
            console.log("prevLocation : ", prevLocation);
            console.log("newLocation : ", location);

            return prevLocation?.google_place_id === location.google_place_id ? {} : location
        });
    }


    /*
        for the receipt link
     */
    // Get event lodging, meals, and activities
    const eventLodging = PA_GlobalObject.Planning.lodging || [];
    const eventMeals = PA_GlobalObject.Planning.meals || [];
    const eventActivities = PA_GlobalObject.Planning.activities || [];
    const eventFlights = PA_GlobalObject.Planning.flights || [];

    function handleReceiptLinkChange(section_id, _section) {

        console.log("handleReceiptLinkChange : "+ section_id + " : "+ _section);

        //if the section id is -1 then no need to look anything up
        if (section_id === -1 || (eventReceipt.section === _section && eventReceipt.section_item === section_id)){
            setEventReceipt(prev => ({
                ...prev,
                section: prev.section === _section && prev.section_item === section_id ? "General" : _section,
                section_item: section_id === -1 ? "" : section_id,
            }))
        } else {
            const categoryLookup = {
                Lodging: eventLodging.find((lodging) => lodging.id === section_id),
                Meals: eventMeals.find((meal) => meal.id === section_id),
                Activities: eventActivities.find((activity) => activity.id === section_id),
                Flights: eventFlights.find((flight) => flight.id === section_id),
            };

            const selectedCategory = categoryLookup[_section];

            if (selectedCategory) {
                let _amount = selectedCategory.amount; // Preserve existing amount
                let _currency = selectedCategory.currency; // Preserve existing currency
                let _location = selectedCategory.location; // Preserve existing location
                let _date_of_service = selectedCategory.date; //preserve existing date

                // Find the matching attendee (any kind, not just business expense)
                const matchingAttendee = selectedCategory.attendees?.find(
                    (att) => att.id === eventReceipt.attendee_id
                );

                _amount = matchingAttendee ? parseFloat(matchingAttendee.cost || matchingAttendee.amount_total || 0) : 0;

                //If the selected category has time_table.date[0] data, update it
                if (selectedCategory.time_table?.dates?.[0]){
                    _date_of_service = selectedCategory.time_table.dates[0].date;
                    setReceiptServiceDate(selectedCategory.time_table.dates[0].date);
                }

                // If the selected category has location data, update it
                if (selectedCategory.location) {
                    _location = {
                        google_place_id: selectedCategory.location.google_place_id || "",
                        latitude: selectedCategory.location.latitude || 0,
                        longitude: selectedCategory.location.longitude || 0,
                        name: selectedCategory.location.name || "",
                        formatted_address: selectedCategory.location.formatted_address || "",
                        address: selectedCategory.location.address || "",
                        city: selectedCategory.location.city || "",
                        state: selectedCategory.location.state || "",
                        zip: selectedCategory.location.zip || "",
                        country: selectedCategory.location.country || "",
                        phone_prefix: selectedCategory.location.phone_prefix || "",
                        phone: selectedCategory.location.phone || "",
                    };
                }

                handleLocationSelect(_location);

                setEventReceipt(prev => ({
                    ...prev,
                    section: _section,
                    section_item: section_id,
                    amount: _amount,
                    currency: _currency,
                    date: _date_of_service
                }))
            }
        }
    }




    /*
        for the receipt amount
     */
    const [anchorChangeCurrencyEl, setAnchorChangeCurrencyEl] = useState(null);
    const handleChangeCurrencyClick = (event, code) => {
        console.log("changing currency to : "+code);
        const _new_currency_code = code;
        setEventReceipt(prevState => ({
            ...prevState,
            currency: _new_currency_code
        }));

        handleChangeCurrencyClose();
    };
    const handleChangeCurrencyClose = () => {
        setAnchorChangeCurrencyEl(null);
    };
    const [receiptServiceDate, setReceiptServiceDate] = useState(eventReceipt.date);
    useEffect(() => {
        console.log("receiptServiceDate has been updated : ", receiptServiceDate);
        setEventReceipt(prevState => ({
            ...prevState,
            date: receiptServiceDate
        }));
    }, [receiptServiceDate]);
    const [editModeBusinessExpense, setEditModeBusinessExpense] = useState(false);



    /*
        for the receipt photo
     */
    const [receiptFile, setReceiptFile] = useState({});
    const [useExperimentalAi, setUseExperimentalAi] = useState(true);
    const [loadingAI, setLoadingAI] = useState(false);
    // Dropzone setup to handle file uploads
    const onDrop = useCallback((acceptedFiles) => {
        acceptedFiles.forEach((file) => {
            // Ensure file type is valid
            if (!file.type || file.type === "0") {
                console.error(`Skipped "${file.name}" due to an invalid MIME type.`);
                return;
            }

            const validTypes = ["image/jpeg", "image/png", "image/gif", "image/webp", "application/pdf"];
            if (!validTypes.includes(file.type)) {
                console.error(`Skipped "${file.name}" due to an invalid file type: ${file.type}`);
                return;
            }

            const reader = new FileReader();
            reader.onload = () => {

                setEventReceipt(prev => ({
                    ...prev,
                    file_name: file.name,
                    file_type: file.type,
                    file_size: file.size,
                    full_data: reader.result
                }))

                const receipt = {
                    name: file.name,
                    type: file.type,
                    size: file.size,
                    full_data: reader.result,
                    private: false,
                };
                setReceiptFile(receipt);

            };

            reader.readAsDataURL(file);
        });
    }, []);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        maxFiles: 1,
        accept: {
            "image/jpeg": [],
            "image/png": [],
            "image/gif": [],
            "image/webp": [],
            "application/pdf": [],
        }, // Explicitly define accepted MIME types
    });
    // Process AI Receipts (Only runs if AI is enabled)
    const [processedFiles, setProcessedFiles] = useState(new Set()); // Tracks already processed files
    useEffect(() => {

        if (useExperimentalAi && receiptFile) {
            setLoadingAI(true);

        }
    }, [useExperimentalAi, receiptFile]);



    /*
        for the receipt notes
    */
    const [ notes, setNotes ] = useState(eventReceipt.notes);
    useEffect(() => {
        setEventReceipt(prev => ({
            ...prev,
            notes: notes
        }))
    }, [notes]);


    const sectionOptions = ['Lodging', 'Meals', 'Activities', 'Flights', 'Transportation', 'Supplies', 'Incidentals', 'Shopping', 'General'];
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSelect = (newSection) => {

        /*
            changing category will break any section_item link
            so we have to alert for that
         */

        setEventReceipt(prev => ({
            ...prev,
            section: newSection,
            section_item: ""
        }));
        handleClose();
    };
    const tabIcons = [
        { key: 'Location', icon: 'icon-map-marker', label: 'Location', color: '#ff6f61' },
        { key: 'Link', icon: 'icon-link', label: 'Link', color: '#d4af37' },
        { key: 'Amount', icon: 'icon-wallet', label: 'Amount', color: '#2e8b57' },
        { key: 'Photo', icon: 'icon-picture2', label: 'Photo', color: '#4ec3f3' },
        { key: 'Notes', icon: 'icon-pencil2', label: 'Notes', color: '#6c757d' },
    ];



    return (

        <Card
            sx={{
                borderRadius: '5px',
                border: '1px solid #f09637',
                marginTop: '10px'
            }}
        >

            {/*
                    this is the main content area with the icons down
                    the left side and the meal content on the right
                 */}
            <Box sx={{display: "flex", width: "100%"}}>

                <Box
                    sx={{
                        minWidth: "55px", // a bit wider for label readability
                        backgroundColor: 'rgb(249, 249, 249)',
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        padding: "8px 0",
                        borderRight: "1px solid #e0e0e0",
                    }}
                >
                    {tabIcons.map(({ key, icon, label, color }) => (
                        <Box
                            key={key}
                            onClick={() => handleFooterItemClick(key)}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginBottom: '12px',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                transform: receiptTabSelected === key ? 'scale(1.05)' : 'scale(1)',
                            }}
                        >
                            <IconButton
                                sx={{
                                    backgroundColor: receiptTabSelected === key ? `${color}20` : 'transparent',
                                    borderRadius: '10px',
                                    padding: '6px',
                                    transition: 'background-color 0.2s ease-in-out',
                                }}
                            >
                                <i
                                    className={icon}
                                    style={{
                                        fontSize: '18px',
                                        color: receiptTabSelected === key ? color : '#428ce2',
                                    }}
                                />
                            </IconButton>
                            <Typography
                                variant="caption"
                                sx={{
                                    fontSize: '10px',
                                    textAlign: 'center',
                                    color: receiptTabSelected === key ? color : '#428ce2',
                                    fontWeight: receiptTabSelected === key ? '600' : '400',
                                }}
                            >
                                {label}
                            </Typography>
                        </Box>
                    ))}
                </Box>

                <Box sx={{ flexGrow: 1, position: 'relative' }}>
                    {/* Show CardMedia only if there’s a file */}
                    {
                        eventReceipt.file_type ? (
                            eventReceipt.file_type.startsWith("image/") ? (
                                <CardMedia component="img" height="100" image={eventReceipt.full_data || eventReceipt.thumbnail_data} alt={eventReceipt.file_name} />
                            ) : (
                                <CardMedia
                                    sx={{ height: 100, display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#f0f0f0" }}
                                >
                                    <Typography variant="caption">{eventReceipt.file_type}</Typography>
                                </CardMedia>
                            )
                        ) :null
                    }

                    {/* heading */}
                    <Box sx={{ padding: '0 16px 16px 16px' }}>
                        {/* Receipt # and Amount on the same line */}
                        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ width: "100%", mt: 1 }}>
                            {/* Left: Icon and Section Label */}
                            <Box
                                display="flex"
                                alignItems="center"
                                gap={1}
                                onClick={handleClick}
                                sx={{ cursor: 'pointer' }}
                            >
                                <i className="icon-helm" title={eventReceipt.section} />
                                <Typography variant="body2" color="textSecondary">
                                    {eventReceipt.section}
                                </Typography>
                            </Box>
                            {/* Menu Popup */}
                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                {sectionOptions.sort().map((section) => (
                                    <MenuItem
                                        key={section}
                                        selected={section === eventReceipt.section}
                                        onClick={() => handleSelect(section)}
                                    >
                                        {section}
                                    </MenuItem>
                                ))}
                            </Menu>

                            {/* Right: Amount */}
                            <Box display="flex" alignItems="center">
                                <Typography variant="subtitle2" sx={{ color: '#006064', fontWeight: 600 }}>
                                    {new Intl.NumberFormat(undefined, {
                                        style: 'currency',
                                        currency: eventReceipt.currency || 'USD',
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    }).format(parseFloat(eventReceipt.amount) || 0)}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    {/* Receipt Date of Service */}
                    {eventReceipt.date && eventReceipt.date !== "" && (
                        <Box sx={{ textAlign: 'right', padding: '0 16px 0 0' }}>
                            <Typography variant="caption" color="textSecondary">
                                {dayjs(eventReceipt.date, 'YYYY-MM-DD').format('ddd, MMM D')}
                            </Typography>
                        </Box>
                    )}

                    {/* Business Location Details */}
                    <Box sx={{ padding: '0 16px 16px 16px' }}>
                        {eventReceipt.location && (eventReceipt.location.name || eventReceipt.location.address) && (
                            <Box sx={{ marginTop: '15px' }}>
                                <Typography variant="subtitle2" color="textSecondary" sx={{ display: 'block' }}>
                                    {eventReceipt.location.name}
                                </Typography>
                                <Typography variant="caption" color="textSecondary" sx={{ display: 'block' }}>
                                    {eventReceipt.location.address}
                                </Typography>
                                <Typography variant="caption" color="textSecondary" sx={{ display: 'block' }}>
                                    {eventReceipt.location.city} {eventReceipt.location.state} {eventReceipt.location.zip}
                                </Typography>
                                <Typography variant="caption" color="textSecondary" sx={{ display: 'block' }}>
                                    {eventReceipt.location.country}
                                </Typography>
                                {eventReceipt.location.phone && (
                                    <Typography variant="caption" color="textSecondary" sx={{ display: 'block' }}>
                                        {eventReceipt.location.phone_prefix} {eventReceipt.location.phone}
                                    </Typography>
                                )}
                            </Box>
                        )}
                    </Box>

                    {/* notes */}
                    {
                        notes.length > 0 && (
                            <Box
                                sx={{
                                    backgroundColor: '#fcf9dd',
                                    borderRadius: '10px',
                                    padding: '0 5px',
                                    margin: '10px'
                                }}
                            >
                                <Typography variant="caption" sx={{ display: "block", ml: "5px" }} color="text.secondary">
                                    <strong>Notes:</strong> {notes}
                                </Typography>
                            </Box>
                        )
                    }

                    {/* Public/Private Toggle Below */}
                    <Box
                        sx={{
                            padding: '0 16px 16px 16px',
                            display: 'flex',
                            justifyContent: 'flex-end', // Align to right
                            alignItems: 'center',
                        }}
                    >
                        <FormControlLabel
                            control={
                                <Switch
                                    size="small"
                                    checked={eventReceipt.private}
                                    onChange={() =>
                                        setEventReceipt(prev => ({
                                            ...prev,
                                            private: !prev.private
                                        }))
                                    }
                                />
                            }
                            label="Private"
                            sx={{ '.MuiFormControlLabel-label': { fontSize: '12px' } }}
                        />
                    </Box>

                </Box>

            </Box>

            {/*  this is the area below for all editing  */}
            <CardContent sx={{display:receiptTabSelected?'block':'none'}}>
                {
                    selectedAction === "Location" ? (
                        <>
                            <TabContext sx={{position: 'relative'}} value={tabValueLocation}>
                                <TabList
                                    sx={{
                                        borderBottom: 1,
                                        borderColor: 'divider',
                                        backgroundColor: 'rgba(251, 251, 251, 0.8)',
                                        backdropFilter: 'blur(6px)',
                                    }}
                                    centered
                                    variant="fullWidth"
                                    onChange={handleTabLocationChange}
                                    aria-label="Location"
                                >
                                    <Tab
                                        label="Search"
                                        value="search"
                                    />
                                    <Tab
                                        label="Locations"
                                        value="locations"
                                    />
                                    <Tab
                                        label="Address"
                                        value="address"
                                    />
                                </TabList>

                                <TabPanel value="search" sx={{padding: '24px 0'}}>

                                    {/* Right-Aligned Button Group */}
                                    <Box sx={{display: 'flex', justifyContent: 'flex-end', mb: 2}}>
                                        <ButtonGroup variant="text" aria-label="outlined button group">
                                            <Button
                                                style={{
                                                    fontSize: '11px',
                                                    backgroundColor: mapSearchType === 'establishment' ? 'rgba(198, 226, 255, 0.8)' : 'initial'
                                                }}
                                                onClick={() => handleSearchTypeChange('establishment')}
                                            >
                                                Establishment
                                            </Button>
                                            <Button
                                                style={{
                                                    fontSize: '11px',
                                                    backgroundColor: mapSearchType === 'address' ? 'rgba(198, 226, 255, 0.8)' : 'initial'
                                                }}
                                                onClick={() => handleSearchTypeChange('address')}
                                            >
                                                Residence
                                            </Button>
                                        </ButtonGroup>
                                    </Box>

                                    {/* Input Fields with Borders */}
                                    <Box
                                        sx={{
                                            position: 'relative',
                                            zIndex: 9999, // ensures the dropdown appears above other elements
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                        }}
                                    >
                                        {mapSearchType === 'establishment' && (
                                            <InputBase
                                                sx={{
                                                    display: 'block',
                                                    flex: 1,
                                                    border: '1px solid rgba(0, 0, 0, 0.23)',
                                                    borderRadius: '4px',
                                                    padding: '6px 12px',
                                                    backgroundColor: 'white'
                                                }}
                                                placeholder='Establishment Name'
                                                inputProps={{'aria-label': 'search establishments'}}
                                                value={mapSearchText}
                                                onChange={handleMapSearchInput}
                                                inputRef={inputRefEstablishment}
                                                onFocus={attachAutocompleteEstablishment}
                                                onBlur={removePacContainerEstablishment}
                                            />
                                        )}

                                        {mapSearchType === 'address' && (
                                            <InputBase
                                                sx={{
                                                    display: 'block',
                                                    flex: 1,
                                                    border: '1px solid rgba(0, 0, 0, 0.23)',
                                                    borderRadius: '4px',
                                                    padding: '6px 12px',
                                                    backgroundColor: 'white'
                                                }}
                                                placeholder='Residential Address'
                                                inputProps={{'aria-label': 'search residential addresses'}}
                                                value={mapSearchText}
                                                onChange={handleMapSearchInput}
                                                inputRef={inputRefResidential}
                                                onFocus={attachAutocompleteResidential}
                                                onBlur={removePacContainerResidential}
                                            />
                                        )}

                                    </Box>
                                </TabPanel>

                                <TabPanel value="locations" sx={{padding: '24px 0'}}>
                                    <Box style={{flex: '1'}}>
                                        <List dense>
                                            {uniqueLocations.length > 0 ? (
                                                uniqueLocations.map((location, index) => (
                                                    <ListItem key={index} sx={{alignItems: "flex-start"}}
                                                              button>
                                                        <Checkbox
                                                            checked={receiptLocation?.google_place_id === location.google_place_id}
                                                            onChange={() => handleLocationSelect(location)}
                                                            sx={{padding: "0 8px"}}
                                                        />
                                                        <ListItemText
                                                            primary={location.name || "Unnamed Location"}
                                                            secondary={location.address || "No Address Available"}
                                                        />
                                                    </ListItem>
                                                ))
                                            ) : (
                                                <Typography variant="body2"
                                                            sx={{textAlign: "center", color: "gray"}}>
                                                    No Event locations to choose from yet
                                                </Typography>
                                            )}
                                        </List>

                                    </Box>
                                </TabPanel>

                                <TabPanel value="address" sx={{padding: '24px 0'}}>
                                    <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, width: '100%'}}>

                                        {/* Location Name */}
                                        <TextField
                                            label="Name"
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            value={receiptLocation.name}
                                            onChange={(event) => handleLocationFieldChange(event, "name")}
                                        />

                                        {/* Address */}
                                        <TextField
                                            label="Address"
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            value={receiptLocation.address}
                                            onChange={(event) => handleLocationFieldChange(event, "address")}
                                        />

                                        {/* City */}
                                        <TextField
                                            label="City"
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            value={receiptLocation.city}
                                            onChange={(event) => handleLocationFieldChange(event, "city")}
                                        />

                                        {/* State */}
                                        <TextField
                                            label="State"
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            value={receiptLocation.state}
                                            onChange={(event) => handleLocationFieldChange(event, "state")}
                                        />

                                        {/* Zip Code */}
                                        <TextField
                                            label="Zip Code"
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            value={receiptLocation.zip}
                                            onChange={(event) => handleLocationFieldChange(event, "zip")}
                                        />

                                        {/* Country */}
                                        <TextField
                                            label="Country"
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            value={receiptLocation.country}
                                            onChange={(event) => handleLocationFieldChange(event, "country")}
                                        />

                                    </Box>
                                </TabPanel>
                            </TabContext>
                        </>
                    ) : null
                }
                {
                    selectedAction === "Link" ? (
                        <Box sx={{ marginTop: "10px", display: "flex", flexDirection: "column", padding: '0 10px' }}>
                            {/* Lodging Category */}
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        size="small"
                                        checked={eventReceipt.section === "Lodging" && eventReceipt.section_item === ""}
                                        onChange={() => {
                                            handleReceiptLinkChange(-1,"Lodging");
                                        }}
                                    />
                                } // Empty placeholder, no actual checkbox
                                componentsProps={{
                                    typography: { fontSize: '14px' }
                                }}
                                label="Lodging"
                            />
                            <FormGroup sx={{ pl: 2, marginBottom: '20px'}}> {/* Indented list of subcategories */}
                                {eventLodging.map((lodging) => (
                                    <FormControlLabel
                                        key={lodging.id}
                                        control={
                                            <Checkbox
                                                size="small"
                                                checked={eventReceipt.section === "Lodging" && eventReceipt.section_item === lodging.id}
                                                onChange={() => {
                                                    handleReceiptLinkChange(lodging.id,"Lodging");
                                                }}
                                            />
                                        }
                                        componentsProps={{
                                            typography: { fontSize: '14px', width: '100%' }
                                        }}
                                        sx={{ width: '100%', mt: 0 }}
                                        label={
                                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                                <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', pr: 2 }}>
                                                    {lodging.name}
                                                </Box>
                                                <Typography
                                                    variant="body2"
                                                    sx={{ minWidth: 60, textAlign: 'right', whiteSpace: 'nowrap', flexShrink: 0 }}
                                                    fontWeight="bold"
                                                >
                                                    {(() => {
                                                        const matchingAttendee = lodging.attendees?.find(
                                                            (att) => att.id === eventReceipt.attendee_id
                                                        );

                                                        // Pick attendee amount if exists, else lodging total
                                                        const amount = matchingAttendee?.cost ?? lodging.amount_total;

                                                        if (amount != null) {
                                                            return new Intl.NumberFormat(undefined, {
                                                                style: 'currency',
                                                                currency: lodging.currency || 'USD',
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            }).format(parseFloat(amount) || 0);
                                                        } else {
                                                            return '';
                                                        }
                                                    })()}
                                                </Typography>
                                            </Box>
                                        }
                                    />
                                ))}
                            </FormGroup>

                            {/* Meals Category */}
                            <FormControlLabel
                                control={<Checkbox
                                    size="small"
                                    checked={eventReceipt.section === "Meals" && eventReceipt.section_item === ""}
                                    onChange={() => {
                                        handleReceiptLinkChange(-1,"Meals");
                                    }}
                                />}
                                componentsProps={{
                                    typography: { fontSize: '14px' }
                                }}
                                label="Meals"
                            />
                            <FormGroup sx={{ pl: 2, marginBottom: '20px'}}>
                                {eventMeals
                                    .slice()
                                    .sort((a, b) => (a.title || a.name || '').localeCompare(b.title || b.name || ''))
                                    .map((meal) => (
                                        <FormControlLabel
                                            key={meal.id}
                                            control={
                                                <Checkbox
                                                    size="small"
                                                    checked={eventReceipt.section === "Meals" && eventReceipt.section_item === meal.id}
                                                    onChange={() => {
                                                        handleReceiptLinkChange(meal.id,"Meals");
                                                    }}
                                                />
                                            }
                                            sx={{ width: '100%', mt: 0 }}
                                            componentsProps={{
                                                typography: { fontSize: '14px', width: '100%' }
                                            }}
                                            label={
                                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                                    <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', pr: 2 }}>
                                                        {meal.title || capitalizeFirstLetter(meal.name) || ""}
                                                    </Box>
                                                    <Typography
                                                        variant="body2"
                                                        sx={{ minWidth: 60, textAlign: 'right', whiteSpace: 'nowrap', flexShrink: 0 }}
                                                        fontWeight="bold"
                                                    >
                                                        {(() => {
                                                            const matchingAttendee = meal.attendees?.find(
                                                                (att) => att.id === eventReceipt.attendee_id
                                                            );

                                                            // Pick attendee amount if exists, else meal total
                                                            const amount = matchingAttendee?.cost ?? meal.amount_total;

                                                            if (amount != null) {
                                                                return new Intl.NumberFormat(undefined, {
                                                                    style: 'currency',
                                                                    currency: meal.currency || 'USD',
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }).format(parseFloat(amount) || 0);
                                                            } else {
                                                                return '';
                                                            }
                                                        })()}

                                                    </Typography>
                                                </Box>
                                            }
                                        />
                                    ))
                                }
                            </FormGroup>

                            {/* Activities Category */}
                            <FormControlLabel
                                control={<Checkbox
                                    size="small"
                                    checked={eventReceipt.section === "Activities" && eventReceipt.section_item === ""}
                                    onChange={() => {
                                        handleReceiptLinkChange(-1,"Activities");
                                    }}
                                />}
                                componentsProps={{
                                    typography: { fontSize: '14px' }
                                }}
                                label="Activities"
                            />
                            <FormGroup sx={{ pl: 2, marginBottom: '20px'}}>
                                {eventActivities.map((activity) => (
                                    <FormControlLabel
                                        key={activity.id}
                                        control={
                                            <Checkbox
                                                size="small"
                                                checked={eventReceipt.section === "Activities" && eventReceipt.section_item === activity.id}
                                                onChange={() => {
                                                    handleReceiptLinkChange(activity.id,"Activities");
                                                }}
                                            />
                                        }
                                        sx={{ width: '100%', mt: 0 }}
                                        componentsProps={{
                                            typography: { fontSize: '14px', width: '100%' }
                                        }}
                                        label={
                                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                                <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', pr: 2 }}>
                                                    {activity.title || ""}
                                                </Box>
                                                <Typography
                                                    variant="body2"
                                                    sx={{ minWidth: 60, textAlign: 'right', whiteSpace: 'nowrap', flexShrink: 0 }}
                                                    fontWeight="bold"
                                                >
                                                    {(() => {
                                                        const matchingAttendee = activity.attendees?.find(
                                                            (att) => att.id === eventReceipt.attendee_id
                                                        );

                                                        // Pick attendee amount if exists, else meal total
                                                        const amount = matchingAttendee?.cost ?? activity.amount_total;

                                                        if (amount != null) {
                                                            return new Intl.NumberFormat(undefined, {
                                                                style: 'currency',
                                                                currency: activity.currency || 'USD',
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            }).format(parseFloat(amount) || 0);
                                                        } else {
                                                            return '';
                                                        }
                                                    })()}

                                                </Typography>
                                            </Box>
                                        }
                                    />
                                ))}
                            </FormGroup>

                            {/* Flights Category */}
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        size="small"
                                        checked={eventReceipt.section === "Flights" && eventReceipt.section_item === ""}
                                        onChange={() => handleReceiptLinkChange(-1, "Flights")}
                                    />
                                }
                                componentsProps={{ typography: { fontSize: '14px' } }}
                                label="Flights"
                            />

                            <FormGroup sx={{ pl: 2, marginBottom: '20px'}}>
                                {eventFlights.map((flight) => (
                                    <FormControlLabel
                                        key={flight.id}
                                        control={
                                            <Checkbox
                                                size="small"
                                                checked={eventReceipt.section === "Flights" && eventReceipt.section_item === flight.id}
                                                onChange={() => {
                                                    handleReceiptLinkChange(flight.id,"Flights");
                                                }}
                                            />
                                        }
                                        label={flight.title}
                                    />
                                ))}
                            </FormGroup>

                            {/* Shopping, Supplies, Incidentals, Transportation (Single Categories without Subcategories) */}
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        size="small"
                                        checked={eventReceipt.section === "Supplies" && eventReceipt.section_item === ""}
                                        onChange={() => {
                                            handleReceiptLinkChange(-1,"Supplies");
                                        }}
                                    />
                                }
                                componentsProps={{
                                    typography: { fontSize: '14px' }
                                }}
                                label="Supplies"
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        size="small"
                                        checked={eventReceipt.section === "Incidentals" && eventReceipt.section_item === ""}
                                        onChange={() => {
                                            handleReceiptLinkChange(-1,"Incidentals");
                                        }}
                                    />
                                }
                                componentsProps={{
                                    typography: { fontSize: '14px' }
                                }}
                                label="Incidentals"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        size="small"
                                        checked={eventReceipt.section === "Shopping" && eventReceipt.section_item === ""}
                                        onChange={() => {
                                            handleReceiptLinkChange(-1,"Shopping");
                                        }}
                                    />
                                }
                                componentsProps={{
                                    typography: { fontSize: '14px' }
                                }}
                                label="Shopping"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        size="small"
                                        checked={eventReceipt.section === "Transportation" && eventReceipt.section_item === ""}
                                        onChange={() => {
                                            handleReceiptLinkChange(-1,"Transportation");
                                        }}
                                    />
                                }
                                componentsProps={{
                                    typography: { fontSize: '14px' }
                                }}
                                label="Transportation"
                            />
                            <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    size="small"
                                                                    checked={eventReceipt.section === "General" && eventReceipt.section_item === ""}
                                                                    onChange={() => {
                                                                        handleReceiptLinkChange(-1,"General");
                                                                    }}
                                                                />
                                                            }
                                                            componentsProps={{
                                                                typography: { fontSize: '14px' }
                                                            }}
                                                            label="General"
                                                        />
                        </Box>
                    ) : null
                }
                {
                    selectedAction === "Amount" ? (
                        <Box sx={{ display: "flex", flexDirection: "column", width: "100%", gap: 1 }}>
                            {/* Line 1: Amount & Currency */}
                            <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
                                <TextField
                                    fullWidth
                                    label="Amount"
                                    name="amount"
                                    type="text"
                                    value={eventReceipt.amount}
                                    onChange={(e) =>
                                        setEventReceipt((prev) => ({
                                            ...prev,
                                            amount: e.target.value
                                        }))}
                                    variant="standard"
                                    sx={{ flex: 1 }}
                                />
                                <IconButton
                                    sx={{ fontSize: '12px', color: 'initial', ml: 1 }}
                                    aria-label="change-currency"
                                    onClick={(e) => setAnchorChangeCurrencyEl(e.currentTarget)}
                                >
                                    {eventReceipt.currency}
                                </IconButton>
                                <Menu
                                    anchorEl={anchorChangeCurrencyEl}
                                    open={Boolean(anchorChangeCurrencyEl)}
                                    onClose={() => setAnchorChangeCurrencyEl(null)}
                                >
                                    {currencyList.map((option) => (
                                        <MenuItem
                                            key={option.code}
                                            selected={option.code === eventReceipt.currency}
                                            onClick={(e) => {
                                                handleChangeCurrencyClick(e, option.code);
                                                setAnchorChangeCurrencyEl(null);
                                            }}
                                        >
                                            {option.code} : {option.name}
                                        </MenuItem>
                                    ))}
                                </Menu>
                            </Box>

                            {/* Line 2: Date of Service */}
                            <Box sx={{ display: "flex", alignItems: "center", width: "100%" , mb:1}}>
                                <DatePicker
                                    sx={{ width: '100%' }}
                                    label="Date of Service"
                                    value={receiptServiceDate && receiptServiceDate !== "" ? dayjs(receiptServiceDate, 'YYYY-MM-DD') : null}
                                    onChange={(e)=> setReceiptServiceDate(e.format('YYYY-MM-DD'))}
                                />
                            </Box>

                            {/* Line 3: Business Expense */}
                            <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            size="small"
                                            checked={eventReceipt.is_business_expense}
                                            onChange={() =>
                                                setEventReceipt(prev => ({
                                                    ...prev,
                                                    is_business_expense: !prev.is_business_expense,
                                                    business_expense_amount: prev.is_business_expense ? 0 : prev.business_expense_amount
                                                }))
                                            }
                                        />
                                    }
                                    label="Business"
                                    sx={{ '.MuiFormControlLabel-label': { fontSize: '12px' } }}
                                />

                                <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 1 }}>
                                    {editModeBusinessExpense ? (
                                        <TextField
                                            label="Amount"
                                            value={eventReceipt.business_expense_amount}
                                            onChange={(e) => {
                                                const inputValue = e.target.value;
                                                if (/^[0-9.,]*$/.test(inputValue)) {
                                                    const formattedValue = inputValue.replace(/,/g, "");
                                                    setEventReceipt(prev => ({
                                                        ...prev,
                                                        business_expense_amount: formattedValue
                                                    }));
                                                }
                                            }}
                                            variant="standard"
                                            sx={{ minWidth: '80px', maxWidth: '100px', textAlign: 'right' }}
                                        />
                                    ) : (
                                        <Typography sx={{fontSize:'14px'}}>
                                            {parseFloat(eventReceipt.business_expense_amount || 0).toFixed(2)}&nbsp;{eventReceipt.currency}
                                        </Typography>
                                    )}
                                    <i
                                        className={editModeBusinessExpense ? 'icon-check' : 'icon-pencil'}
                                        style={{ cursor: 'pointer', fontSize: editModeBusinessExpense ? '14px' : '12px' }}
                                        onClick={() => setEditModeBusinessExpense(!editModeBusinessExpense)}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    ) : null
                }
                {
                    selectedAction === "Photo" ? (
                        <Card sx={{display: "flex", flexDirection: "column", padding: "10px"}}>
                            <CardContent sx={{display: "flex", flexDirection: "column", gap: 1}}>
                                {/* Dropzone for File Uploads */}
                                <Box
                                    {...getRootProps()}
                                    sx={{
                                        border: "2px dashed gray",
                                        textAlign: "center",
                                        cursor: "pointer",
                                        borderRadius: "8px"
                                    }}
                                >
                                    <input {...getInputProps()} />
                                    {isDragActive
                                        ? <Typography variant="caption">Drop the receipt here...</Typography>
                                        : <Typography variant="caption">Drag & drop receipt here, or click to select</Typography>}
                                </Box>

                                {/* AI Processing Toggle */}
                                <FormControlLabel
                                    control={<Switch checked={useExperimentalAi}
                                                     onChange={() => setUseExperimentalAi(!useExperimentalAi)}/>}
                                    label={
                                        <Typography variant="caption" color="textSecondary">
                                            Use AI
                                        </Typography>
                                    }
                                />

                                {/* AI Helper Text */}
                                <Typography variant="caption" color="textSecondary">
                                    AI will extract receipt data.
                                </Typography>
                            </CardContent>
                        </Card>
                    ) : null
                }
                {
                    selectedAction === "Notes" ? (
                        <TextField
                            fullWidth
                            label="Notes"
                            multiline
                            rows={4}
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                        />
                    ) : null
                }
            </CardContent>
        </Card>

    )

}

export default ReceiptsEditCard;